<template>
  <div>
    <template v-if="!$route.meta.isKeepAlive">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
export default {
  name: 'RouteView',
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/route-view.vue